import { render, staticRenderFns } from "./RatingDirectionsStatDirectionView.vue?vue&type=template&id=728dad2d"
import script from "./RatingDirectionsStatDirectionView.vue?vue&type=script&lang=js"
export * from "./RatingDirectionsStatDirectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports